import React, { Component } from 'react'

export default class About extends Component {
  render () {
    return (
      <div className='aboutComponent'>
        <h2>About Us</h2>
        <p>
          Give "treat yourself" a whole new meaning with a trip out to Hair With A View.  A luxury home-style salon nestled in the heart of Brooklyn’s luscious Valley.
        </p>
        <p>
          Just a few minutes out of Wellington City, our salon offers clients an escape from the hustle and bustle of everyday life and and the chance to slow it all down. Relax and retreat above the valley below in our peaceful hair haven, where we encourage you to swap out the to-do list for some quality YOU time.
        </p>
        <p>
          Whether you’re in need of a chat, or would rather soak up the tranquility of the space in our massage chair, we pride ourselves on making sure your hair experience is exactly what you came here looking for. 
        </p>
        <p>
          Another thing we refuse to compromise on is quality. All our products are carefully sourced from the best of the best in the hair sphere to give your hair the love it deserves. We are specialists in all things hair, whether it’s a fresh colour, a blow-wave or a whole new cut - you can put your trust in us.
        </p>
        <p>
          Without fail, we always strive to achieve our clients’ hair goals, while still maintaining the health of their locks. Our guarantee is that you will walk out of our salon having seen the difference outstanding professional service makes, knowing you made the right choice for you and your hair.
        </p>
      </div>
    )
  }
}
